"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.getOrCreateWallet = void 0;
var derivation_1 = require("../derivation");
var promise_1 = require("../promise");
var Ledger_1 = require("../api/Ledger");
var env_1 = require("../env");
var errors_1 = require("./errors");
exports.getOrCreateWallet = (0, promise_1.atomicQueue)(function (_a) {
    var core = _a.core, walletName = _a.walletName, currency = _a.currency, derivationMode = _a.derivationMode;
    return __awaiter(void 0, void 0, void 0, function () {
        var poolInstance, wallet, config, configExtra, _b, _c, _i, k, v, derivationScheme, KEYCHAIN_OBSERVABLE_RANGE, ledgerExplorer, endpoint, currencyCore, err_1;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    poolInstance = core.getPoolInstance();
                    return [4 /*yield*/, core.DynamicObject.newInstance()];
                case 1:
                    config = _d.sent();
                    configExtra = (0, derivation_1.getLibcoreConfig)(currency, derivationMode);
                    if (!configExtra) return [3 /*break*/, 5];
                    _b = [];
                    for (_c in configExtra)
                        _b.push(_c);
                    _i = 0;
                    _d.label = 2;
                case 2:
                    if (!(_i < _b.length)) return [3 /*break*/, 5];
                    k = _b[_i];
                    v = configExtra[k];
                    if (!(typeof v === "string")) return [3 /*break*/, 4];
                    return [4 /*yield*/, config.putString(k, v)];
                case 3:
                    _d.sent();
                    _d.label = 4;
                case 4:
                    _i++;
                    return [3 /*break*/, 2];
                case 5:
                    derivationScheme = (0, derivation_1.getDerivationScheme)({
                        currency: currency,
                        derivationMode: derivationMode
                    });
                    return [4 /*yield*/, config.putString("KEYCHAIN_DERIVATION_SCHEME", derivationScheme)];
                case 6:
                    _d.sent();
                    return [4 /*yield*/, config.putBoolean("DEACTIVATE_SYNC_TOKEN", (0, env_1.getEnv)("DISABLE_SYNC_TOKEN"))];
                case 7:
                    _d.sent();
                    KEYCHAIN_OBSERVABLE_RANGE = (0, env_1.getEnv)("KEYCHAIN_OBSERVABLE_RANGE");
                    if (!KEYCHAIN_OBSERVABLE_RANGE) return [3 /*break*/, 9];
                    return [4 /*yield*/, config.putInt("KEYCHAIN_OBSERVABLE_RANGE", KEYCHAIN_OBSERVABLE_RANGE)];
                case 8:
                    _d.sent();
                    _d.label = 9;
                case 9:
                    ledgerExplorer = (0, Ledger_1.findCurrencyExplorer)(currency);
                    if (!ledgerExplorer) return [3 /*break*/, 13];
                    endpoint = ledgerExplorer.endpoint;
                    if (!endpoint) return [3 /*break*/, 11];
                    return [4 /*yield*/, config.putString("BLOCKCHAIN_EXPLORER_API_ENDPOINT", endpoint)];
                case 10:
                    _d.sent();
                    _d.label = 11;
                case 11: return [4 /*yield*/, config.putString("BLOCKCHAIN_EXPLORER_VERSION", ledgerExplorer.version)];
                case 12:
                    _d.sent();
                    _d.label = 13;
                case 13:
                    _d.trys.push([13, 16, , 18]);
                    return [4 /*yield*/, poolInstance.getCurrency(currency.id)];
                case 14:
                    currencyCore = _d.sent();
                    return [4 /*yield*/, poolInstance.createWallet(walletName, currencyCore, config)];
                case 15:
                    wallet = _d.sent();
                    return [2 /*return*/, wallet];
                case 16:
                    err_1 = _d.sent();
                    if (!(0, errors_1.isAlreadyExistingWalletError)(err_1)) {
                        throw err_1;
                    }
                    // actually wallet was existing...
                    // we need to sync the config in case it changed
                    return [4 /*yield*/, poolInstance.updateWalletConfig(walletName, config)];
                case 17:
                    // actually wallet was existing...
                    // we need to sync the config in case it changed
                    _d.sent();
                    return [3 /*break*/, 18];
                case 18: return [4 /*yield*/, poolInstance.getWallet(walletName)];
                case 19:
                    wallet = _d.sent();
                    return [2 /*return*/, wallet];
            }
        });
    });
}, function (_a) {
    var walletName = _a.walletName;
    return walletName;
});
//# sourceMappingURL=getOrCreateWallet.js.map